import { IDENTIFIER } from '../constants';
import TextInput from './TextInput';
import NumberField from './NumberField';
import EmailField from './EmailField';
import CheckboxField from './CheckboxField';
import DatePickerField from './DatePickerField';
import TimePickerField from './TimePickerField';
import RadioField from './RadioField';
import UploadFileField from './UploadFileField';
import MultiSelectField from './MultiSelectField';
import SelectField from './SelectField';
import TextAreaField from './TextAreaField';
import CkEditorField from './CkEditorField';
import PhoneInputField from './PhoneInputField';
import MultiplePhoneInputField from './MultiplePhoneInputField';
import DropdownWithDetails from '../../selectWithDetails/dropdownWithDetails';
import MultipleEmailInputField from './MultipleEmailInputField';
import ExistingId from './ExistingId';
import GroupTextField from './GroupTextField';
import YouTubeUrlsField from './YouTubeUrlsField';

export const FormFields = {
  [IDENTIFIER.INPUTTEXT]: TextInput,
  [IDENTIFIER.INPUTNUMBER]: NumberField,
  [IDENTIFIER.INPUTEMAIL]: EmailField,
  [IDENTIFIER.FILE]: UploadFileField,
  [IDENTIFIER.CHECKBOX]: CheckboxField,
  [IDENTIFIER.RADIO]: RadioField,
  [IDENTIFIER.DATEPICKER]: DatePickerField,
  [IDENTIFIER.TIMEPICKER]: TimePickerField,
  [IDENTIFIER.SELECT]: SelectField,
  [IDENTIFIER.MULTISELECT]: MultiSelectField,
  [IDENTIFIER.TEXTAREA]: TextAreaField,
  [IDENTIFIER.EDITOR]: CkEditorField,
  [IDENTIFIER.PHONE]: PhoneInputField,
  [IDENTIFIER.MULTIPLEPHONE]: MultiplePhoneInputField,
  [IDENTIFIER.DROPDOWNWITHDETAILS]: DropdownWithDetails,
  [IDENTIFIER.MULTIPLEEMAIL]: MultipleEmailInputField,
  [IDENTIFIER.EXISTINGID]: ExistingId,
  [IDENTIFIER.GROUPNUMBER]: GroupTextField,
  [IDENTIFIER.YOUTUBEURLS]: YouTubeUrlsField,
  [IDENTIFIER.PASSWORD]: TextInput,
};
